var React = require('react');

function XREALLogoBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.5 0H4.675L7.85 5.905H8.155L11.35 0H15.53L10.675 8.12L15.53 16.335H11.35L8.155 10.335H7.85L4.675 16.335H0.5L5.305 8.12L0.5 0ZM18 0H25.445C29.035 0 30.67 2.38 30.67 5.225C30.67 7.14 29.945 9.225 27.87 10.035L31.115 16.335H27.075L24.23 10.385H21.595V16.335H18V0ZM24.815 7.56C26.095 7.56 27.055 6.815 27.055 5.25C27.055 3.875 26.285 2.965 24.745 2.965H21.595V7.56H24.815ZM44.935 0H33.935V16.335H44.97V13.37H37.55V9.405H43.78V6.58H37.55V2.965H44.935V0ZM57 0L62.58 16.335H58.61L57.4 12.275H51.97L50.755 16.335H46.79L52.39 0H57ZM56.56 9.45L54.795 3.525H54.605L52.835 9.45H56.56ZM68.5 0H64.875V16.335H74.545V13.37H68.5V0Z","fill":"black"}));
}

XREALLogoBlack.defaultProps = {"width":"75","height":"17","viewBox":"0 0 75 17","fill":"none"};

module.exports = XREALLogoBlack;

XREALLogoBlack.default = XREALLogoBlack;
